import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import { EventCard, type Event } from '@/components/events/EventCard';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

interface UpcomingEventsSectionProps {
  communityId: string;
  enabled?: boolean;
}

export function UpcomingEventsSection({ communityId, enabled = true }: UpcomingEventsSectionProps) {
  const { data, isLoading } = useSWR(
    enabled ? `/api/communities/${communityId}/events` : null,
    fetcher
  );

  if (!enabled) return null;

  const upcomingEvents = data?.upcomingEvents || [];

  if (!isLoading && upcomingEvents.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-2xl font-bold tracking-tight text-foreground">Upcoming Events</h3>

      {isLoading ? (
        <div className="flex gap-4 overflow-x-auto pb-2">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="w-[85vw] sm:w-[320px] md:w-[350px] shrink-0 h-64 rounded-xl bg-muted animate-pulse"
            />
          ))}
        </div>
      ) : (
        <div className="flex gap-4 overflow-x-auto pb-2 snap-x snap-mandatory">
          {upcomingEvents.map((event: Event) => (
            <div key={event.id} className="snap-start shrink-0 w-[85vw] sm:w-[320px] md:w-[350px]">
              <EventCard event={event} communityId={communityId} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
